<template>
  <el-dialog
    :class="isPreview ? 'public-preview-dialog' : 'teacher-dialog'"
    :title="isPreview ? '正文预览' : form.id ? '正文编辑' : '新增'"
    :visible.sync="dialogVisible"
    :width="isPreview ? '1000px' : '1300px'"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :top="isPreview ? 0 : '15vh'"
  >
    <!-- 预览 -->
    <div class="public-preview-boxs" v-if="isPreview">
      <div class="box-container" v-if="isPreview">
        <div class="aboutUs-container">
          <p class="title" v-html="form.title"></p>
          <div class="content-box" v-html="form.content"></div>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="form-container" v-else>
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="标题" prop="title">
          <!-- <el-input
            v-model="form.title"
            placeholder="请输入标题"
            maxLength="200"
          >
          </el-input> -->
          <QuillEditor2 v-model="form.title" :maxlength="200" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="正文" prop="content">
          <quill-editor :value="form.content" @input="getValue"></quill-editor>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!isPreview">
      <div>
        <el-button @click="onSubmit('ruleForm', true)">预 览</el-button>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit('ruleForm', false)">
          确 认
        </el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import QuillEditor from '@/components/QuillEditor'
import QuillEditor2 from '@/components/QuillEditor/index2.vue'

export default {
  components: {
    QuillEditor,
    QuillEditor2
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPreview: false,
      form: {
        title: '',
        content: ''
      },
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '正文不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 父组件传给子组件的数据
    init(data) {
      this.form = {
        id: data.id || null,
        name: data.name || '',
        title: data.title,
        content: data.content
      }
    },
    getValue(value) {
      this.form.content = value
    },
    // 关闭弹窗
    handleClose() {
      if (!this.isPreview && this.form.content && this.form.content !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isPreview ? (this.isPreview = false) : this.$emit('close')
        }).catch(() => {});
      } else {
        this.isPreview ? (this.isPreview = false) : this.$emit('close')
      }
    },
    // 提交表单/是否预览
    onSubmit(formName, isPreview) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (isPreview) {
            this.isPreview = isPreview
            return
          }
          if (this.form.title === '<p><br></p>') {
            return this.$message.error('请输入标题')
          }
          if (this.form.content === '<p><br></p>') {
            return this.$message.error('请输入正文')
          }
          this.$emit('submit', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-dialog {
  ::v-deep .el-dialog {
    // .el-dialog__header {
    //   // background-color: #909399;
    //   padding: 10px;
    //   .el-dialog__title {
    //     font-size: 15px;
    //     // color: #fff;
    //   }
    //   .el-dialog__headerbtn {
    //     top: 10px;
    //     i {
    //       // color: #fff;
    //     }
    //   }
    // }
    .el-dialog__body {
      max-height: 500px;
      overflow-y: scroll;
    }
    // .el-form {
    //   .el-form-item {
    //     margin-bottom: 25px;
    //     .el-form-item__error {
    //       margin: 5px 0;
    //     }
    //     .el-form-item__label {
    //       font-size: 12px;
    //     }
    //     .el-input {
    //       // width: 200px;
    //     }
    //     .editor {
    //       // width: 500px;
    //       .wordNumber {
    //         display: none;
    //       }
    //       .avatar-uploader,
    //       .avatar-uploader-video {
    //         width: 0;
    //         height: 0;
    //       }
    //     }
    //   }
    //   .el-form-item__label {
    //     font-size: 12px;
    //   }
    //   .el-input {
    //     // width: 200px;
    //   }
    //   .editor {
    //     // width: 500px;
    //     .wordNumber {
    //       display: none;
    //     }
    //     .avatar-uploader,
    //     .avatar-uploader-video {
    //       width: 0;
    //       height: 0;
    //     }
    //   }
    // }
  }
  .el-dialog__footer {
    width: 100%;
    border-top: 1px solid #ddd;
    padding-top: 15px;
  }
}
</style>
<style lang="scss">
.box-container {
  width: 877px;
  max-width: 877px;
  height: 700px;
  overflow-y: scroll;
  margin: 0 auto;

  .aboutUs-container {
    // padding: 50px 63px;
    .title {
      // font-size: 36px;
      // font-weight: bold;
      // color: #145bc3;
      text-align: center;
    }
    .content-box {
      color: #333;
      margin-top: 22px;
      line-height: 28px;
      font-size: 14px;
      p {
        img {
          max-width: 877px;
          text-align: center;
          display: block;
          margin: 40px auto;
        }
      }
    }
  }
}
</style>